const getKlevuBadge = (item) => {
  let badge = null

  if (item.tags != undefined) {
    // Handle both Klevu string format "['tag1', 'tag2']" and Shopify array format
    let tags = Array.isArray(item.tags)
      ? item.tags
      : item.tags.replace('[', '').replace(']', '').trim().split(',')
    tags = tags.map((tag) => tag.replace(/['"]/g, '').trim())

    const priorityTag = tags.find(
      (tag) =>
        tag === '__label:Coming soon' ||
        tag === '__label:Notify me' ||
        tag === '__label:Sold out'
    )

    if (priorityTag) {
      return priorityTag === '__label:Sold out' ? 'Sold out' : 'Notify me'
    }

    const discountTag = tags.find(
      (tag) => tag.includes('__label') && tag.includes('%')
    )

    if (discountTag) {
      return discountTag.replace('__label:', '').replace('__label', '').trim()
    }

    for (let tag of tags) {
      if (tag === '__label:Best seller' || tag === '__label Best seller') {
        badge = 'Best seller'
      } else if (tag === '__label:New' || tag === '__label New') {
        badge = 'New'
      } else if (tag === '__label:Seasonal' || tag === '__label Seasonal') {
        badge = 'Seasonal'
      }
    }

    if (!badge) {
      for (let tag of tags) {
        if (
          tag.includes('__label') &&
          !tag.includes('Best seller') &&
          !tag.includes('New') &&
          !tag.includes('Seasonal') &&
          !tag.includes('%')
        ) {
          badge = tag.replace('__label:', '').replace('__label', '').trim()
          break
        }
      }
    }
  }
  return badge
}

const getKlevuCategoryBadge = (item) => {
  let categoryBadges = []
  let openAirTechBadge = null

  if (item.tags != undefined) {
    // Handle both Klevu string format "['tag1', 'tag2']" and Shopify array format
    let tags = Array.isArray(item.tags) ? item.tags : item.tags.split(',')

    for (let tag of tags) {
      tag = tag.replace('[', '').replace(']', '').replace(/['"]/g, '').trim()

      if (tag == 'Group_Home') categoryBadges.push('home')
      if (tag == 'Group_Car') categoryBadges.push('car')
      if (tag == 'Group_Sample') categoryBadges.push('sample')
      if (tag == 'type_Smartvial') categoryBadges.push('smart-vial')
      if (tag.includes('Openair'))
        openAirTechBadge = tag.replace('Openairtech_', 'Open Air Tech-')
    }
  }
  if (openAirTechBadge !== null) {
    categoryBadges.push(openAirTechBadge)
  }
  return categoryBadges
}

export { getKlevuBadge, getKlevuCategoryBadge }
